export const MAP_FEATURES = {
    ACCESSIBILITY: {
        NORMAL: 1,
        INACCESSIBLE: 2,
        CLOSED: 3,
        DIFFICULT: 4,
        EASY: 5,
    },
};
